"use strict";
/**
 * Novig Market Fetcher
 *
 * Thinner than its Kalshi and PM-US counterparts: the server projects Novig's
 * shapes into ours (`src/shared/novig.ts`). This maps them onto `Market`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.novigEventToDisplayEvent = novigEventToDisplayEvent;
exports.novigProjectedMarketToMarket = novigProjectedMarketToMarket;
exports.fetchNovigEvents = fetchNovigEvents;
exports.fetchNovigEventMarkets = fetchNovigEventMarkets;
const novig_1 = require("../api/novig");
const cache_1 = require("./cache");
const constants_1 = require("./constants");
function novigEventToDisplayEvent(event) {
    return {
        id: event.id,
        title: event.title,
        subtitle: event.subtitle,
        category: event.league,
        scheduledDate: event.scheduledStart,
    };
}
/**
 * The one place Novig's outcome slots meet `Market`'s YES-shaped fields.
 *
 * For Novig, "yes" is slot A and "no" is slot B: positions, not sides (server
 * `novig/outcomes.ts`). Each slot's label and id travel together, so a button
 * always names the outcome it trades.
 */
function novigProjectedMarketToMarket(market) {
    const [a, b] = market.outcomes;
    return {
        id: market.id,
        venue: "novig",
        title: market.title,
        subtitle: (0, constants_1.novigMarketTypeLabel)(market.marketType),
        category: market.marketType,
        // Its ids are UUIDs, so the picker shows the title, as Novig sends it.
        label: market.title,
        marketCategory: market.marketType,
        marketCategoryLabel: (0, constants_1.novigMarketTypeLabel)(market.marketType),
        marketCoarseType: (0, constants_1.novigCoarseType)(market.marketType),
        strike_price: 0,
        status: market.status,
        // No list prices: the live book is the only Novig price (S2.3).
        bid: 0,
        ask: 0,
        yesSubtitle: a.name,
        noSubtitle: b.name,
        outcomes: [a.name, b.name],
        novigOutcomeIds: [a.id, b.id],
    };
}
/** Fetch open events (upcoming and live) for a Novig league. */
async function fetchNovigEvents(league) {
    const events = await (0, novig_1.listNovigEvents)(league);
    (0, cache_1.setNovigEventCache)(events);
    return events.map(novigEventToDisplayEvent);
}
/** Fetch one Novig event's markets. */
async function fetchNovigEventMarkets(eventId) {
    console.log(`Fetching markets for Novig event: ${eventId}...`);
    const markets = await (0, novig_1.getNovigEventMarkets)(eventId);
    if (markets.length === 0) {
        throw new Error(`No markets found for Novig event: ${eventId}`);
    }
    console.log(`Fetched ${markets.length} markets for Novig event: ${eventId}`);
    return markets.map(novigProjectedMarketToMarket);
}
